import { makeStyles } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

const useStyles = makeStyles(() => ({
  skeleton: {
    borderRadius: 4,
  },
}))

const Loading = () => {
  const classes = useStyles()
  return (
    <Box
      p={2}
      display="flex"
      flexDirection="column"
      gridGap={8}
      data-testid="loading-component"
    >
      <Skeleton
        variant="rect"
        animation="wave"
        width={120}
        height={37}
        className={classes.skeleton}
      />
      <Skeleton
        variant="rect"
        animation="wave"
        height={85}
        className={classes.skeleton}
      />
      <Skeleton
        variant="rect"
        animation="wave"
        width={120}
        height={37}
        className={classes.skeleton}
      />
      <Skeleton
        variant="rect"
        animation="wave"
        height={186}
        className={classes.skeleton}
      />
    </Box>
  )
}

export default Loading
